module.exports = __webpack_public_path__ + "images/tomato-ee14d4bcd8defe22d810c835992f2033.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/tomato.jpeg
// module id = 235
// module chunks = 0